import { Contexte } from '@/domaine/Contexte'

export const IndépendantContexte: Contexte = {
	'entreprise . imposition': "'IS'",
	'entreprise . catégorie juridique': "'EI'",
	'entreprise . catégorie juridique . EI . auto-entrepreneur': 'non',
}
